import React, { useState } from "react";
import Button from "./Button";

const CallbackForm = () => {
  const buttonText = "Submit";

  const [formData, setFormData] = useState({
    name: "",
    age: "",
    gender: "",
    city: "",
    phoneNumber: "",
    retreatDateSuitability: "",
    retreatPriceSuitability: "",
    reasonToJoin: "",
    otherQuestion: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    const payload = {
      name: formData.name,
      age: formData.age,
      gender: formData.gender,
      city: formData.city,
      phone: formData.phoneNumber,
      date_suits: formData.retreatDateSuitability,
      price_suitable: formData.retreatPriceSuitability,
      reason: formData.reasonToJoin,
      question: formData.otherQuestion,
    };

    fetch(
      "https://zbpje4azgliercmqvfqkh34bqm0mlmwm.lambda-url.ap-south-1.on.aws/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .catch((error) => {
        console.error("Error submitting form:", error);
        alert("⚠️ An error occurred. Please try again later.");
      })
      .finally(() => {
        setIsSubmitting(false);

        alert("✅ Form submitted successfully!");

        setFormData({
          name: "",
          age: "",
          gender: "",
          city: "",
          phoneNumber: "",
          retreatDateSuitability: "",
          retreatPriceSuitability: "",
          reasonToJoin: "",
          otherQuestion: "",
        });
      });
  };

  return (
    <section className="relative py-16 md:py-20 bg-[#F7F1EA] overflow-hidden">
      {/* BG GLOWS */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#E8C8A7]/20 blur-3xl rounded-full" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#DDBA99]/15 blur-3xl rounded-full" />

      <div className="relative max-w-4xl mx-auto px-6">
        <div
          className="
            relative
            overflow-hidden
            rounded-[34px]
            bg-white/75
            backdrop-blur-2xl
            border
            border-white/40
            shadow-[0_20px_60px_rgba(20,10,0,.06)]
            p-6
            md:p-10
          "
        >
          {/* CARD GLOW */}
          <div className="absolute top-0 right-0 w-56 h-56 bg-[#F4D8BE]/20 blur-3xl rounded-full" />

          <div className="relative z-10">
            {/* HEADER */}
            <div className="text-center mb-8">
              <div
                className="
                  inline-flex
                  items-center
                  px-4
                  py-2
                  rounded-full
                  bg-[#FFF4E8]
                  border
                  border-[#F3DDC7]
                  text-[#C26B2E]
                  text-[10px]
                  tracking-[.18em]
                  uppercase
                  font-medium
                  mb-4
                "
              >
                Get In Touch
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-3">
                Have a Query?
              </h2>

              <p className="text-[#5F5751] text-sm md:text-base">
                Fill this form and we'll get back to you shortly.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Name + Age */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full rounded-2xl border border-[#EFE3D7] bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary transition-all"
                />

                <input
                  type="number"
                  name="age"
                  placeholder="Age"
                  value={formData.age}
                  onChange={handleChange}
                  min="18"
                  max="99"
                  required
                  className="w-full rounded-2xl border border-[#EFE3D7] bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary transition-all"
                />
              </div>

              {/* Gender + City */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                  className="w-full rounded-2xl border border-[#EFE3D7] bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary transition-all"
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>

                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  className="w-full rounded-2xl border border-[#EFE3D7] bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary transition-all"
                />
              </div>

              {/* Phone */}
              <input
                type="tel"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
                pattern="[0-9]{10}"
                required
                className="w-full rounded-2xl border border-[#EFE3D7] bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary transition-all"
              />

              {/* Date + Price */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-secondary text-sm font-semibold mb-2">
                    Does the retreat date suit you?
                  </label>

                  <select
                    name="retreatDateSuitability"
                    value={formData.retreatDateSuitability}
                    onChange={handleChange}
                    required
                    className="w-full rounded-2xl border border-[#EFE3D7] bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary transition-all"
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div>
                  <label className="block text-secondary text-sm font-semibold mb-2">
                    Is the retreat price suitable?
                  </label>

                  <select
                    name="retreatPriceSuitability"
                    value={formData.retreatPriceSuitability}
                    onChange={handleChange}
                    required
                    className="w-full rounded-2xl border border-[#EFE3D7] bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary transition-all"
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              {/* Reason */}
              <textarea
                name="reasonToJoin"
                placeholder="What’s your reason to join this retreat?"
                value={formData.reasonToJoin}
                onChange={handleChange}
                minLength="5"
                maxLength="100"
                rows="4"
                required
                className="w-full rounded-2xl border border-[#EFE3D7] bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary transition-all"
              />

              {/* Question */}
              <textarea
                name="otherQuestion"
                placeholder="Any other question?"
                value={formData.otherQuestion}
                onChange={handleChange}
                minLength="5"
                maxLength="100"
                rows="4"
                className="w-full rounded-2xl border border-[#EFE3D7] bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary transition-all"
              />

              {/* Button */}
              <div className="flex justify-center pt-2">
                <Button
                  text={isSubmitting ? "Submitting..." : buttonText}
                  type="submit"
                  variant="primary"
                  size="md"
                  disabled={isSubmitting}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallbackForm;